
/* injects from baggage-loader */

'use strict';

export default class AccountProjectsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		// this.$log.log(this.projects);
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/projects/account.projects.controller.js